// extracted by mini-css-extract-plugin
export var button = "_fj-0";
export var donut = "_fj-1";
export var donutFill = "_fj-3";
export var donutTrack = "_fj-2";